module.exports = __webpack_public_path__ + "static/media/DINPro-Light_13935.e0be9bd5.ttf";